"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsValidatorLazy = void 0;
var _TermsAndConditionsValidator = require("./TermsAndConditionsValidator");
var _TermsAndConditionsValidatorProviders = require("./TermsAndConditionsValidatorProviders");
var _jsxRuntime = require("react/jsx-runtime");
const TermsAndConditionsValidatorLazy = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsAndConditionsValidatorProviders.TermsAndConditionsValidatorProviders, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TermsAndConditionsValidator.TermsAndConditionsValidator, {})
});
exports.TermsAndConditionsValidatorLazy = TermsAndConditionsValidatorLazy;
